export default __webpack_public_path__ + "locales/bg/About.json?hash=caf1007bde5a19ff191ac68c727cd561";